export const ADD_NOTE_BUTTON = 'ADD_NOTE_BUTTON';
export const ASSET_DETAIL_DATA = 'ASSET_DETAIL_DATA';
export const ASSET_FAULT_DIAGNOSTIC_WIDGET = 'ASSET_FAULT_DIAGNOSTIC_WIDGET';
export const ASSET_LOCATION_WIDGET = 'ASSET_LOCATION_WIDGET';
export const ASSET_OVERVIEW = 'ASSET_OVERVIEW';
export const ASSET_SUMMARY_WIDGET = 'ASSET_SUMMARY_WIDGET';
export const CANCEL_SERVICE_REQUEST_BUTTON = 'CANCEL_SERVICE_REQUEST_BUTTON';
export const CASE_ASSETS_WIDGET = 'CASE_ASSETS_WIDGET';
export const CASE_CLASSIC_ASSET_DETAIL_BUTTON = 'CASE_CLASSIC_ASSET_DETAIL_BUTTON';
export const CASE_COMPLAINT_WIDGET = 'CASE_COMPLAINT_WIDGET';
export const CASE_DETAIL_DATA = 'CASE_DETAIL_DATA';
export const CASE_FAULT_DIAGNOSTIC_WIDGET = 'CASE_FAULT_DIAGNOSTIC_WIDGET';
export const CASE_LOCATION_WIDGET = 'CASE_LOCATION_WIDGET';
export const CASE_NOTES_WIDGET = 'CASE_NOTES_WIDGET';
export const CASE_OVERVIEW = 'CASE_OVERVIEW';
export const CASE_SERVICE_PROVIDER_WIDGET = 'CASE_SERVICE_PROVIDER_WIDGET';
export const CASE_SERVICE_REQUEST_INFO_WIDGET = 'CASE_SERVICE_REQUEST_INFO_WIDGET';
export const CASE_STATUS_WIDGET = 'CASE_STATUS_WIDGET';
export const ESTIMATE_INVOICE_DECIDED_WIDGET = 'ESTIMATE_INVOICE_DECIDED_WIDGET';
export const ESTIMATE_INVOICE_PENDING_WIDGET = 'ESTIMATE_INVOICE_PENDING_WIDGET';
export const JUMP_TO_BUTTON = 'JUMP_TO_BUTTON';
export const OPEN_EVENTS_WIDGET = 'OPEN_EVENTS_WIDGET';
export const OPTIONS_BUTTON = 'OPTIONS_BUTTON';
export const QR_CODE_WIDGET = 'QR_CODE_WIDGET';
export const REQUEST_SERVICE_BUTTON = 'REQUEST_SERVICE_BUTTON';
export const SERVICE_REQUEST_ASSETS_WIDGET = 'SERVICE_REQUEST_ASSETS_WIDGET';
export const SERVICE_REQUEST_COMPLAINT_WIDGET = 'SERVICE_REQUEST_COMPLAINT_WIDGET';
export const SERVICE_REQUEST_DETAIL_DATA = 'SERVICE_REQUEST_DETAIL_DATA';
export const SERVICE_REQUEST_LOCATION_WIDGET = 'SERVICE_REQUEST_LOCATION_WIDGET';
export const SERVICE_REQUEST_NOTES_WIDGET = 'SERVICE_REQUEST_NOTES_WIDGET';
export const SERVICE_REQUEST_OVERVIEW = 'SERVICE_REQUEST_OVERVIEW';
export const SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET = 'SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET';
export const SERVICE_REQUEST_SERV_REQ_INFO_WIDGET = 'SERVICE_REQUEST_SERV_REQ_INFO_WIDGET';

export default [
  ADD_NOTE_BUTTON,
  ASSET_DETAIL_DATA,
  ASSET_FAULT_DIAGNOSTIC_WIDGET,
  ASSET_LOCATION_WIDGET,
  ASSET_OVERVIEW,
  ASSET_SUMMARY_WIDGET,
  CANCEL_SERVICE_REQUEST_BUTTON,
  CASE_ASSETS_WIDGET,
  CASE_CLASSIC_ASSET_DETAIL_BUTTON,
  CASE_COMPLAINT_WIDGET,
  CASE_DETAIL_DATA,
  CASE_FAULT_DIAGNOSTIC_WIDGET,
  CASE_LOCATION_WIDGET,
  CASE_NOTES_WIDGET,
  CASE_OVERVIEW,
  CASE_SERVICE_PROVIDER_WIDGET,
  CASE_SERVICE_REQUEST_INFO_WIDGET,
  CASE_STATUS_WIDGET,
  ESTIMATE_INVOICE_DECIDED_WIDGET,
  ESTIMATE_INVOICE_PENDING_WIDGET,
  JUMP_TO_BUTTON,
  OPEN_EVENTS_WIDGET,
  OPTIONS_BUTTON,
  QR_CODE_WIDGET,
  REQUEST_SERVICE_BUTTON,
  SERVICE_REQUEST_ASSETS_WIDGET,
  SERVICE_REQUEST_COMPLAINT_WIDGET,
  SERVICE_REQUEST_DETAIL_DATA,
  SERVICE_REQUEST_LOCATION_WIDGET,
  SERVICE_REQUEST_NOTES_WIDGET,
  SERVICE_REQUEST_OVERVIEW,
  SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET,
  SERVICE_REQUEST_SERV_REQ_INFO_WIDGET,
];



// WEBPACK FOOTER //
// ./setup/ComponentRegistry/constants.js